import React, { useState } from 'react';
import { navLinks, personalInfo } from '../../data/portfolioData';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaGithub } from 'react-icons/fa';

const Sidebar = ({ activeSection, darkMode, toggleMode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false);
  };

  const navIcons = {
    home: 'fa-home', about: 'fa-user', achievements: 'fa-trophy',
    skills: 'fa-code', education: 'fa-graduation-cap',
    experience: 'fa-briefcase', work: 'fa-folder-open',
    blog: 'fa-newspaper', contact: 'fa-envelope'
  };

  return (
    <>
      <button className="sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>
        <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
      </button>
      {isOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setIsOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 998 }}
        />
      )}

      <aside className={`portfolio-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-profile">
          <img
            src={personalInfo.profileImage}
            alt={personalInfo.name}
            className="sidebar-avatar"
            onError={e => { e.target.src = 'https://ui-avatars.com/api/?name=CG&background=f97316&color=fff&size=110'; }}
          />
          <h1 className="sidebar-name">{personalInfo.name}</h1>
          <span className="sidebar-title">Full Stack Developer and Devops</span>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {navLinks.map(link => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  className={activeSection === link.id ? 'active' : ''}
                  onClick={e => { e.preventDefault(); scrollTo(link.id); }}
                >
                  <i className={`fas ${navIcons[link.id] || 'fa-circle'}`}></i>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-social">
            {personalInfo.social.facebook && (
              <a href={personalInfo.social.facebook} target="_blank" rel="noreferrer" title="Facebook">
                <FaFacebookF />
              </a>
            )}
            {personalInfo.social.instagram && (
              <a href={personalInfo.social.instagram} target="_blank" rel="noreferrer" title="Instagram">
                <FaInstagram />
              </a>
            )}
            {personalInfo.social.linkedin && (
              <a href={personalInfo.social.linkedin} target="_blank" rel="noreferrer" title="LinkedIn">
                <FaLinkedinIn />
              </a>
            )}
            {personalInfo.social.github && (
              <a href={personalInfo.social.github} target="_blank" rel="noreferrer" title="GitHub">
                <FaGithub />
              </a>
            )}
          </div>

          <button className="mode-toggle" onClick={toggleMode} title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
            <i className={`fas ${darkMode ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>

          <p className="sidebar-copyright">
            © Copyright {new Date().getFullYear()} All rights reserved.<br />
            Made with <i className="fas fa-heart" style={{ color: '#e74c3c' }}></i> by{' '}
            <a href="https://chandanprofile.com" target="_blank" rel="noreferrer">Chandan Gupta</a>
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
